import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info-circle-filled",
  "use": "icon-info-circle-filled-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-info-circle-filled\">\n  <path d=\"M24,48A24,24,0,0,1,7.029,7.029,24,24,0,0,1,40.97,40.97,23.842,23.842,0,0,1,24,48Zm0-28a2,2,0,0,0-2,2V33a2,2,0,0,0,4,0V22A2,2,0,0,0,24,20Zm0-7a2,2,0,1,0,2,2A2,2,0,0,0,24,13Z\" fill=\"#currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol